module.exports = __webpack_public_path__ + "img/content_copy_black.4ee9e4e6.svg";